import {renderErrorToast} from "../../../utils/FeedbackMessageUtils";
import {DerivateAssignmentDraftTypes} from "../../../components/Table/components/derivate/DerivateUtils";
import {ModeltypeBasicDto, OptionDto, WorkflowStatusDtoType} from "../../../services/Client";
import DataAdapterOptionsView from "../DataAdapterOptionsView";
import {SelectAction} from "./UDASummaryStep";

export function calculateUpdateItems(selectedItems: DataAdapterOptionsView[], selectedDerivates: ModeltypeBasicDto[]): Map<OptionDto, boolean> {
    const updateItems = new Map<OptionDto, boolean>();

    selectedItems.map((item) => {
        if (selectedDerivates.length > 0 &&
            item.dto.modeltypes &&
            item.dto.modeltypes.find(der => selectedDerivates.find(d => d.objectId === der.modeltypeBasic.objectId) !== undefined &&
                DerivateAssignmentDraftTypes.has(der.assignmentType)) &&
            item.statusValueStates &&
            item.statusView === WorkflowStatusDtoType.MAINTENANCE) {
            updateItems.set(item.dto, false);
        }
    });

    return updateItems;
}

export function handleSelection(items: DataAdapterOptionsView[], updateItems: Map<OptionDto, boolean>, resetFlag: boolean, actionType: SelectAction): Map<OptionDto, boolean> {
    const newItems = new Map(updateItems);

    switch (actionType) {
        case (SelectAction.SingleSelect):
            if (newItems.has(items[0].dto)) {
                newItems.delete(items[0].dto);
            } else {
                newItems.set(items[0].dto, resetFlag);
            }
            break;
        case (SelectAction.SelectAll):
            items.forEach((val: DataAdapterOptionsView) => {
                if (!newItems.has(val.dto)) {
                    newItems.set(val.dto, resetFlag);
                }
            });
            break;
        case (SelectAction.DeselectAll):
            items.forEach((val: DataAdapterOptionsView) => {
                newItems.delete(val.dto);
            });
            break;
        default:
            renderErrorToast({
                message: "ERRORS:UNKNOWN_ACTION",
                timestamp: Date.now()
            });
            break;
    }

    return newItems;
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/updateDraftAssignments/UpdateDraftAssignmentsHelper.tsx